import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectYourBranch: {
    defaultMessage: 'Select your branch',
    id: 'ProvidersList.selectYourBranch',
  },
  branchHeader: {
    defaultMessage: '{groupDisplayName} branches',
    id: 'ProvidersList.branchHeader',
  },
});
